import { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Typography,
} from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { SoftButton, useDialogPaperSx } from "../../hatim/soft/SoftKit";
import { useAddHatimManagerMutation } from "../../../api/hatimManagementApi";

export default function AddHatimManagerModal({ open, hatimTemplateId, onClose, onAdded }) {
  const { t } = useScriptMode();
  const paperSx = useDialogPaperSx();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [addManager, { isLoading }] = useAddHatimManagerMutation();

  useEffect(() => {
    if (!open) {
      setEmail("");
      setError("");
    }
  }, [open]);

  const trimmed = email.trim();
  const canSubmit = !!trimmed && /@/.test(trimmed) && !isLoading;

  const handleSubmit = async () => {
    if (!canSubmit) return;
    try {
      await addManager({ hatimTemplateId, email: trimmed }).unwrap();
      onAdded && onAdded();
      onClose && onClose();
    } catch (err) {
      const msg = err?.message || err?.data?.message || t("hatim_mgmt_action_error");
      setError(msg);
    }
  };

  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="xs" PaperProps={{ sx: paperSx }}>
      <DialogTitle sx={{ fontWeight: 500 }}>{t("hatim_mgmt_add_manager_modal_title")}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          type="email"
          label={t("hatim_mgmt_add_user_email_label")}
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setError("");
          }}
          margin="normal"
        />
        {error ? (
          <Typography color="error" variant="body2" mt={1}>{error}</Typography>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <SoftButton tone="cancel" onClick={onClose}>{t("hatim_mgmt_create_cancel")}</SoftButton>
        <SoftButton tone="success" onClick={handleSubmit} disabled={!canSubmit}>
          {t("hatim_mgmt_repeat_save")}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
}
